import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VotingModule} from '@modules/voting/voting.module';
import {LibImageModule} from '@components/image/lib-image.module';
import {NewsSharingButtonsComponent} from '@shared/modules/shared-news/components/news-sharing-buttons/news-sharing-buttons.component';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {MatChipsModule} from '@angular/material/chips';
import {SharedDialogModule} from '@shared/modules/shared-dialogs/shared-dialog.module';
import {NewsReporterDialogComponent} from '@shared/modules/shared-news/dialogs/news-reporter-dialog/news-reporter-dialog.component';
import {NewsRegisterReporterDialogComponent} from '@shared/modules/shared-news/dialogs/news-register-reporter-dialog/news-register-reporter-dialog.component';
import {NewsRegisterReporterNameComponent} from '@shared/modules/shared-news/dialogs/news-register-reporter-name-dialog/news-register-reporter-name.component';
import {NewsEmptyBannerComponent} from '@shared/modules/shared-news/components/news-emtpy-banner/news-empty-banner.component';
import {NewsSponsorCardComponent} from '@shared/modules/shared-news/components/news-sponsor-card/news-sponsor-card.component';
import {MatCardModule} from '@angular/material/card';
import {SharedCoreModule} from '@shared/shared-core.modules';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import {SharedGamesModule} from '@shared/modules/shared-games/shared-games.module';
import {LibLazyImageModule} from '@components/image/modules/lazy-image/lib-lazy-image.module';
import {NewsPreviewCardComponent} from '@shared/modules/shared-news/components/news-preview-card/news-preview-card.component';
import {SharedVideosModule} from '@shared/modules/shared-videos/shared-videos.module';
import {InViewportModule} from 'ng-in-viewport';
import {SharedSpecialsModule} from '@shared/modules/shared-specials/shared-specials.module';
import { NewsLinkComponent } from './components/news-link/news-link.component';
import { DynamicComponentEmbedDirective } from './directives/dynamic-component-embed.directive';
import { NewsTopComponent } from './components/news-top/news-top.component';
import {LibDirectivesModule} from '@utils/directives/lib-directives.module';
import { NewsRelatedArticlesComponent } from './components/news-related-articles/news-related-articles.component';
import { NewsEmbedButtonComponent } from './components/news-embed-button/news-embed-button.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    VotingModule,
    LibImageModule,
    SharedDialogModule,
    SharedCoreModule,
    LibTableModule,
    SharedGamesModule,
    SharedVideosModule,
    SharedSpecialsModule,
    LibLazyImageModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatChipsModule,
    MatCardModule,
    InViewportModule,
    LibDirectivesModule,
  ],
  declarations: [
    NewsSharingButtonsComponent,
    NewsReporterDialogComponent,
    NewsRegisterReporterDialogComponent,
    NewsRegisterReporterNameComponent,
    NewsEmptyBannerComponent,
    NewsSponsorCardComponent,
    NewsPreviewCardComponent,
    NewsLinkComponent,
    DynamicComponentEmbedDirective,
    NewsTopComponent,
    NewsRelatedArticlesComponent,
    NewsEmbedButtonComponent,
  ],
  exports: [
    NewsSharingButtonsComponent,
    NewsEmptyBannerComponent,
    NewsPreviewCardComponent,
    NewsLinkComponent,
    DynamicComponentEmbedDirective,
    NewsTopComponent,
    NewsSponsorCardComponent,
  ],
})
export class SharedNewsModule { }
